import React from 'react';
import {
  Box,
  CircularProgress,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  Typography,
} from '@mui/material';
import { CHAT_MARK_AS_OPTIONS, chatStatusLabel } from '../../lib/chatSessionStatus';

/**
 * Zendesk-style "Marked as" dropdown for chat session workflow.
 */
export default function ChatSessionStatusMenu({
  currentStatus = 'open',
  disabled = false,
  loading = false,
  onMarkAs,
}) {
  const displayStatus = chatStatusLabel(currentStatus);

  return (
    <Box sx={{ minWidth: { xs: '100%', sm: 220 } }}>
      <FormControl size="small" fullWidth disabled={disabled || loading}>
        <InputLabel id="chat-mark-as-label">Marked as</InputLabel>
        <Select
          labelId="chat-mark-as-label"
          label="Marked as"
          value=""
          displayEmpty
          renderValue={() => (
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
              {loading ? <CircularProgress size={14} /> : null}
              <Typography variant="body2" sx={{ fontWeight: 600 }}>
                {loading ? 'Updating…' : displayStatus}
              </Typography>
            </Box>
          )}
          onChange={(e) => {
            const next = e.target.value;
            if (next) onMarkAs?.(next);
          }}
          sx={{
            backgroundColor: '#ffffff',
            color: '#1e293b',
            '& .MuiSelect-select': { color: '#1e293b' },
            '& .MuiOutlinedInput-notchedOutline': { borderColor: '#cbd5e1' },
          }}
        >
          <MenuItem value="" disabled>
            <em>Change status…</em>
          </MenuItem>
          {CHAT_MARK_AS_OPTIONS.map((opt) => (
            <MenuItem key={opt.value} value={opt.value}>
              {opt.label}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </Box>
  );
}
